"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M13.4801 5.42385C13.1619 5.15868 12.689 5.20167 12.4238 5.51988L7.69058 11.1998C7.30428 11.6633 7.30428 12.3367 7.69058 12.8002L12.4238 18.4802C12.689 18.7984 13.1619 18.8414 13.4801 18.5762C13.7983 18.311 13.8413 17.8381 13.5762 17.5199L8.97628 12L13.5762 6.48016C13.8413 6.16195 13.7983 5.68903 13.4801 5.42385Z';